import { useFeatureValue, useGrowthBook } from "@growthbook/growthbook-react"
import { FC, useEffect } from "react"
import appConfig from "../config/app.config"

interface AdminWhitelistLayerProps {}

const AdminWhitelistLayer: FC<AdminWhitelistLayerProps> = () => {
  const gb = useGrowthBook()
  const hasAccessToOldAdmin = useFeatureValue("admin-ui:has-legacy-admin-access", false)

  // useEffect(() => {
  //   if (gb.ready && gb.getAttributes().email) {
  //     if (!hasAccessToOldAdmin) {
  //       window.location.href = appConfig.newAdminUrl
  //     }
  //   }
  // }, [gb.ready, gb, hasAccessToOldAdmin])

  return null
}

export default AdminWhitelistLayer
